<template>
    <footer id="footer" style="background-image: url(static/assets/images/footer.png);">
        <div class="container">
            <div class="row align-items-center" v-if="instanceName !== 'MAHADEMY'">
                <div class="col-lg-6 copyright">
                    &copy; {{$t('footer.copyright')}} {{getCurrentYear}} {{$t('footer.mkcl_title')}}<br>
                    {{$t('footer.rights_reserved')}}
                </div>
                 <div class="col-lg-6 olinks">
                    <ul> 
                        <!-- <li><a href="#">Terms &amp; Conditions</a></li> -->
                        <!-- <li><a href="#">{{$t('footer.about')}}</a></li>
                        <li><a href="#">{{$t('footer.privacy_policy')}}</a></li>
                        <li><a href="#">{{$t('footer.disclaimer')}}</a></li> -->
                    </ul>
                </div> 
            </div>
            <div v-else>
                <div class="col-lg-12 ">
                   {{$t('footer.mahademy_title')}}  &copy; {{$t('footer.copyright')}} {{getCurrentYear}} {{$t('footer.mkcl_title')}}
                </div>
            </div>
        </div>
        <back-to-top visibleOffset="600" bottom="30px">
          <button type="button" class="btn btn-to-top"><i class="mdi mdi-chevron-up"></i></button>
        </back-to-top>
    </footer>
</template>

<script>
import { INSTANCE_NAME } from '@/components/common/constants.js'
export default {
  name: 'footerArea',
  data () {
    return {
      instanceName: INSTANCE_NAME
    }
  },
  computed: {
    getCurrentYear () {
      var date = new Date()
      var year = date.getFullYear()
      return year
    }
  }
}
</script>
<style lang="scss" scoped>
#footer {text-align: center;
    /*margin-top:100px;*/
    //background: url(static/assets/images/footer.png);
    background-size: cover;
    width: 100%;
    padding: 100px 0 60px 0; font-size: 14px; line-height: 22px; color: #fff;
    /*h4 {
        color: #fff;
        font-size: 16px;
        font-style: italic;
        margin-bottom: 30px;
    }
    p {
        color: #ffffff;
        margin: 0;
        .txt-highlight {
            color: #fff;
        }
    }*/
    .copyright {margin-bottom: 20px;}
    .olinks {font-size: 13px; line-height: 20px;}
    ul {margin: 0; padding: 0;
        li {display: inline-block;
            a {padding: 5px 15px; display: block; color: rgba(#fff, 0.8);
                &:hover, &:focus {text-decoration: none; color: lighten(#1565c0, 30%);}
            }
        }
    }
}

.vue-back-to-top .btn.btn-to-top {padding: 4px 6px; border-radius: 3px; font-size: 24px; line-height: 24px; color: #fff; background: linear-gradient(to right, #77b3f1, #98a2f7, darken(#98a2f7, 5%)); background-position: -2px 0; background-size: 100px 100%; transition: all 0.2s ease-out;
    &:hover {background-position: -52px 0; box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);}
    &:active {background: linear-gradient(to right, #77b3f1, #98a2f7, darken(#98a2f7, 5%)); background-position: -52px 0; background-size: 100px 100%;}
    &:focus {box-shadow: none;}
}


@media (min-width: 768px) {
#footer {padding: 150px 0 90px 0; font-size: 15px; line-height: 25px;
    .olinks {font-size: 14px;}
}
}

@media (min-width: 992px) {
#footer {text-align: left;
    .copyright {margin-bottom: 0;}
    .olinks {text-align: right;}
}
}
</style>



// WEBPACK FOOTER //
// src/components/common/footerArea.vue?f2854514